import { useLocation } from 'react-router-dom';
import styles from './TakweenNotAvailable.module.scss';

interface LocationState {
  grade?: number;
}

const TakweenNotAvailable = (): JSX.Element => {
  const location = useLocation<LocationState>();
  const grade = location.state?.grade || 0;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Program Not Available</h1>
        <p className={styles.description}>The Takween program is not available for your grade level.</p>
        <p className={styles.gradeInfo}>
          This program is designed for students in grades 6-12.
          {grade > 0 && ` You are currently in grade ${grade}.`}
        </p>
        <p className={styles.contactInfo}>
          Please contact your administrator for more information about available programs for your grade level.
        </p>
      </div>
    </div>
  );
};

export default TakweenNotAvailable;
